<template>
  <b-col cols="12" md="6" lg="3">
    <b-card class="text-center shadow-sm h-100" :class="`border-${cor}`">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <div class="d-flex align-items-center" style="gap: 0.5rem">
          <b-icon :icon="icone" :variant="cor" font-scale="1.5" />
          <strong class="ms-3">{{ titulo }}</strong>
        </div>
        <b-icon
          :id="`tooltip-info-${titulo}`"
          icon="info-circle-fill"
          variant="primary"
          class="mr-2"
        />
        <b-tooltip :target="`tooltip-info-${titulo}`" placement="top">
          {{ tituloBIcon }}
        </b-tooltip>
      </div>

      <h4 :class="`text-${cor}`">R$ {{ numberToReal(valor, 2) }}</h4>
      <small class="text-muted"
        >R$ {{ numberToReal(liquido, 2) }} líquido</small
      >
      <div class="mt-2">
        <p>{{ cobrancas }} cobrança(s)</p>
      </div>

      <b-progress
        height="6px"
        :variant="cor"
        :value="valor > 0 ? 100 : 0"
        class="my-3"
      />
    </b-card>
  </b-col>
</template>

<script>
import { SistemaMixin } from "@/modules/Application";

export default {
  mixins: [SistemaMixin],
  name: "InfoBox",
  props: {
    cor: String,
    titulo: String,
    icone: String,
    valor: Number,
    liquido: Number,
    clientes: Number,
    cobrancas: Number,
    tituloBIcon: String,
  },
};
</script>
